export default "__VITE_ASSET__BWBYNDsU__"